import { ArrowRightOutlined, NotificationOutlined } from "@ant-design/icons";
import { Button, notification } from "antd";
import { useEffect } from "react";

import { useLoc } from "@app/shared/lib/hooks";

import { useUIAppState } from "../../UIAppStateProvider";

export const EmailConfirmationMessage: React.FC = () => {
  const UIAppState = useUIAppState();
  const loc = useLoc();

  useEffect(() => {
    if (UIAppState.isEmailConfirmationMessageVisible) {
      notification.warning({
        key: "EmailConfirmationMessage",
        message: loc.word("You should confirm your email"),
        icon: <NotificationOutlined className="fs-16 color-warning" />,
        // eslint-disable-next-line react/jsx-no-useless-fragment
        closeIcon: null,
        placement: "bottomRight",
        duration: 0,
        description: (
          <div className="flex justify-end">
            <Button
              onClick={() =>
                UIAppState.setIsEmailConfirmationModalVisible(true)
              }
              type="primary"
              className="m-0"
            >
              {loc.word("Confirm")}&nbsp;
              <ArrowRightOutlined />
            </Button>
          </div>
        ),
      });
    } else {
      notification.destroy("EmailConfirmationMessage");
    }

    return () => notification.destroy("EmailConfirmationMessage");
  }, [UIAppState, UIAppState.isEmailConfirmationMessageVisible, loc]);

  return null;
};
